import { columnData } from '@api/mapping/__mockData__';
import { keysToCamel } from '@helpers/camelCaseConverter';
import {
  FORMULA,
  NOT_PROVIDED,
} from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/constants';

import type { Column, ColumnOption } from './types';

/**
 * Models incoming conversion toool columns
 */
export const conversionToolColumnsGetModel = (
  /** column data list */
  columns: Array<Column> = columnData
): Array<Column> =>
  columns.map<Column>(column => {
    const camelColumn = keysToCamel(column) as Column;
    return {
      ...camelColumn,
      options:
        camelColumn && camelColumn.options && camelColumn.options.length > 0
          ? camelColumn?.options.map<ColumnOption>(option => {
              if (option.optionType === null) {
                return {
                  ...option,
                  optionType: NOT_PROVIDED,
                };
              }

              if (option.optionType === FORMULA) {
                return {
                  optionType: option?.formula,
                  display: option?.display,
                  requires: option?.requires,
                };
              }

              return option;
            })
          : undefined,
    };
  });
